export default {
    macrotrend: 'on the macro-trend {macrotrend}',
    context: 'Created at {date} by {author}',
    comment: 'Comment',
    view: '1 comment|{cnt} comments'
}
